var map = {
	"./calendar-01.svg": 6080,
	"./chevron-down.svg": 2784,
	"./chevron-up.svg": 2055,
	"./coin-broken.svg": 9328,
	"./copy-right.svg": 7109,
	"./download-01.svg": 7986,
	"./edit-contained.svg": 5445,
	"./eye-closed.svg": 4429,
	"./eye-open.svg": 8166,
	"./globe-03.svg": 9394,
	"./logout-01.svg": 6834,
	"./logout-02.svg": 1374,
	"./mail-01.svg": 9133,
	"./phone.svg": 1185,
	"./plus-01.svg": 4740,
	"./search-02.svg": 269,
	"./telegram.svg": 6414,
	"./user-profile-03.svg": 5169,
	"./wallet-03.svg": 4043,
	"./x-03.svg": 357
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7178;